(function () {
  // Vimeo Click-to-Play Facade (Privacy-Friendly)
  // This prevents third-party cookies until user interaction
  function initVimeoFacade() {
    // Handle hero background videos
    document.querySelectorAll('.hero-block__video-facade').forEach(function (facade) {
      const playButton = facade.querySelector('.hero-block__video-play');
      if (!playButton) return;

      playButton.addEventListener('click', function () {
        const videoSrc = facade.getAttribute('data-video-src');
        if (!videoSrc) return;

        // Create and inject iframe
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', videoSrc);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Background video');
        iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';

        // Remove facade class and play button
        facade.classList.remove('hero-block__video-facade');
        playButton.remove();

        // Add iframe
        facade.appendChild(iframe);

        // Resize the iframe to cover
        setTimeout(function () {
          resizeHeroIframe(facade.closest('.hero-block'));
        }, 100);
      });
    });

    // Handle content-split videos
    document.querySelectorAll('.content-split__video-facade').forEach(function (facade) {
      const playButton = facade.querySelector('.content-split__video-play');
      if (!playButton) return;

      playButton.addEventListener('click', function () {
        const videoSrc = facade.getAttribute('data-video-src');
        const videoId = facade.getAttribute('data-video-id');
        if (!videoSrc) return;

        // Create and inject iframe
        const iframe = document.createElement('iframe');
        iframe.className = 'content-split__iframe';
        iframe.setAttribute('src', videoSrc);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute(
          'allow',
          'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
        );
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Video content');
        iframe.setAttribute('width', '640');
        iframe.setAttribute('height', '360');
        iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';

        // Remove facade class and play button
        facade.classList.remove('content-split__video-facade');
        playButton.remove();

        // Add iframe
        facade.appendChild(iframe);
      });
    });
  }

  // Resize the Vimeo background iframe so it always "covers" the hero container.
  function resizeHeroIframe(container) {
    var wrap = container.querySelector('.hero-block__video-wrap');
    if (!wrap) return;
    var iframe = wrap.querySelector('iframe');
    if (!iframe) return;

    var rect = wrap.getBoundingClientRect();
    var cw = rect.width;
    var ch = rect.height;
    var aspect = 16 / 9;

    // Calculate dimensions that will cover the container while preserving aspect ratio
    var requiredWidth = Math.max(cw, ch * aspect);
    var requiredHeight = Math.max(ch, cw / aspect);

    // Apply size and keep it centered via transform
    iframe.style.width = requiredWidth + 'px';
    iframe.style.height = requiredHeight + 'px';
    iframe.style.top = '50%';
    iframe.style.left = '50%';
    iframe.style.transform = 'translate(-50%, -50%)';
    iframe.style.position = 'absolute';
  }

  function initAll() {
    // Initialize click-to-play facades
    initVimeoFacade();

    // Set up resize handlers for any loaded videos
    var blocks = document.querySelectorAll('.hero-block.has-background-video');
    blocks.forEach(function (block) {
      // run once now
      resizeHeroIframe(block);
      // update on resize
      window.addEventListener('resize', function () {
        resizeHeroIframe(block);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.accordion-toggle').forEach(function (toggle) {
    const content = toggle.nextElementSibling;
    const accordionItem = toggle.closest('.accordion-item');

    if (!content || !content.classList.contains('accordion-content')) {
      return;
    }

    // Initialize: remove hidden attribute but keep height at 0
    if (content.hasAttribute('hidden')) {
      content.removeAttribute('hidden');
    }
    content.style.height = '0';
    content.setAttribute('aria-hidden', 'true');

    toggle.addEventListener('click', function () {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);

      if (!expanded) {
        // Expanding
        if (accordionItem) {
          accordionItem.classList.add('open');
        }
        content.setAttribute('aria-hidden', 'false');
        // Need to get scrollHeight after setting aria-hidden for accurate measurement
        requestAnimationFrame(function () {
          content.style.height = content.scrollHeight + 'px';
        });
      } else {
        // Collapsing: first set to current height, then to 0
        if (accordionItem) {
          accordionItem.classList.remove('open');
        }
        content.style.height = content.scrollHeight + 'px';

        requestAnimationFrame(function () {
          content.style.height = '0';
          content.setAttribute('aria-hidden', 'true');
        });
      }
    });
  });
});
